import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { ConfirmCodeComponent } from './confirm-code/confirm-code.component';
import { EmailComponent } from './email/email.component';
import { Ng2TelInputModule } from '../directives/tel-input/tel-imput.module';
import { NgModule } from '@angular/core';
import { PasswordComponent } from './password/password.compontnt';
import { PhoneComponent } from './phone/phone.component';
import { RouterModule } from '@angular/router';
import { TextComponent } from './text/text.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { PhoneSimpleComponent } from './phone-simple/phone-simple.component';
import { CodeComponent } from './code/code.component';
import { P500UIIconsModule } from '@platform500services/p500-ui-kit';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectComponent } from './select/select.component';
import { SelectWithIconsComponent } from './select-with-icons/select-with-icons.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    Ng2TelInputModule,
    FormsModule,
    P500UIIconsModule,
    NgSelectModule,
    NgxMaskDirective,
  ],
  declarations: [
    ConfirmCodeComponent,
    PasswordComponent,
    TextComponent,
    EmailComponent,
    PhoneComponent,
    PhoneSimpleComponent,
    TooltipComponent,
    CodeComponent,
    SelectComponent,
    SelectWithIconsComponent,
  ],
  providers: [provideNgxMask()],
  exports: [
    ConfirmCodeComponent,
    PasswordComponent,
    TextComponent,
    EmailComponent,
    PhoneComponent,
    PhoneSimpleComponent,
    TooltipComponent,
    CodeComponent,
    SelectComponent,
    SelectWithIconsComponent,
  ],
})
export class FormFieldsModule {}
